module.exports = __webpack_public_path__ + "img/weasley_twins_with_beards.ae6a8c87.jpg";